<app-options-select
  [options]="options()"
  [value]="displayValue()"
  (valueChange)="onValueChange($event)"
  [disabled]="disabled()"
  placeholder="provider.tenderResponse.subcriteriaAttributes.selectYesNo"
  [testId]="'attribute-boolean-' + testIdKey()"
  styleClass="w-40"
/>
